(() => {
  'use strict';

  /* PN8A_STUDENT_EVENTS_COMMUNITIES */

  const dashboard =
    document.querySelector(
      '[data-pnauth-dashboard][data-role="student"]'
    );

  if (!dashboard) return;


  const upcomingRoot =
    dashboard.querySelector(
      '[data-pndash-event-registrations]'
    );

  const attendedRoot =
    dashboard.querySelector(
      '[data-pndash-attended-events]'
    );

  const communitiesSection =
    dashboard.querySelector(
      '[data-pndash-section="communities"]'
    );

  const communitiesRoot =
    communitiesSection?.querySelector(
      '.pndash-wide-empty'
    );


  function escapeHTML(value) {
    return String(value ?? '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB.request(
      `rpc/${name}`,
      '',
      {
        method:'POST',
        body
      }
    );

  }


  function prettyDate(value) {

    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return 'Date TBA';
    }


    return date.toLocaleDateString(
      'en-IN',
      {
        day:'numeric',
        month:'short',
        year:'numeric'
      }
    );

  }


  function prettyTime(value) {

    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '';
    }


    return date.toLocaleTimeString(
      'en-IN',
      {
        hour:'numeric',
        minute:'2-digit'
      }
    );

  }


  function modeLabel(row) {

    if (
      row.mode === 'online'
    ) {
      return 'Online';
    }


    if (
      row.mode === 'hybrid'
    ) {

      return row.venue
        ? `Hybrid · ${row.venue}`
        : 'Hybrid';

    }


    return (
      row.venue ||
      'Venue TBA'
    );

  }


  function eventCard(
    row,
    past = false
  ) {

    const canCancel =
      !past
      &&
      row.registration_status !==
        'cancelled'
      &&
      row.registration_status !==
        'attended';


    return `
      <article
        class="pn8sd-event"
        data-pn8sd-event="${escapeHTML(row.event_id)}"
      >

        <div class="pn8sd-event__date">

          <strong>
            ${escapeHTML(
              new Date(
                row.starts_at
              ).toLocaleDateString(
                'en-IN',
                {
                  day:'2-digit'
                }
              )
            )}
          </strong>

          <span>
            ${escapeHTML(
              new Date(
                row.starts_at
              ).toLocaleDateString(
                'en-IN',
                {
                  month:'short'
                }
              )
            )}
          </span>

        </div>


        <div class="pn8sd-event__main">

          <div class="pn8sd-event__meta">

            <span>
              ${escapeHTML(
                row.event_type || 'Event'
              )}
            </span>

            <span>
              ${escapeHTML(
                row.registration_status
              )}
            </span>

          </div>


          <h4>
            ${escapeHTML(
              row.title
            )}
          </h4>


          <p>
            ${escapeHTML(
              prettyDate(
                row.starts_at
              )
            )}
            ·
            ${escapeHTML(
              prettyTime(
                row.starts_at
              )
            )}
            ·
            ${escapeHTML(
              modeLabel(row)
            )}
          </p>


          ${
            row.ticket_code
              ? `
                <small>
                  Ticket
                  ${escapeHTML(
                    row.ticket_code
                  )}
                </small>
              `
              : ''
          }


          <div class="pn8sd-event__actions">

            ${
              row.meeting_url
                &&
              !past
                ? `
                  <a
                    href="${escapeHTML(
                      row.meeting_url
                    )}"
                    target="_blank"
                    rel="noopener"
                  >
                    Join event ↗
                  </a>
                `
                : ''
            }


            ${
              canCancel
                ? `
                  <button
                    type="button"
                    data-pn8sd-cancel-event="${escapeHTML(
                      row.event_id
                    )}"
                  >
                    Cancel registration
                  </button>
                `
                : ''
            }

          </div>

        </div>

      </article>
    `;

  }


  function renderEvents(
    rows
  ) {

    const now =
      Date.now();


    const active =
      rows.filter(
        row => {

          const start =
            new Date(
              row.starts_at
            ).getTime();


          return (
            row.registration_status !==
              'cancelled'
            &&
            row.registration_status !==
              'attended'
            &&
            (
              !Number.isFinite(start)
              ||
              start >= now
            )
          );

        }
      );


    const attended =
      rows.filter(
        row =>
          row.registration_status ===
            'attended'
          ||
          !!row.checked_in_at
      );


    if (upcomingRoot) {

      if (!active.length) {

        upcomingRoot.innerHTML = `
          <span>◇</span>

          <strong>
            No upcoming event registrations.
          </strong>

          <p>
            When you register for a PeerNest event,
            it will appear here.
          </p>

          <a href="/pages/events">
            Browse events →
          </a>
        `;

      }
      else {

        upcomingRoot.classList.add(
          'pn8sd-live-list'
        );


        upcomingRoot.innerHTML =
          active
            .sort(
              (a,b) =>
                new Date(a.starts_at)
                -
                new Date(b.starts_at)
            )
            .map(
              row =>
                eventCard(
                  row,
                  false
                )
            )
            .join('');

      }

    }


    if (attendedRoot) {

      if (!attended.length) {

        attendedRoot.innerHTML = `
          <span>★</span>

          <strong>
            No attended events yet.
          </strong>

          <p>
            Your event history will build
            here as you attend PeerNest events.
          </p>
        `;

      }
      else {

        attendedRoot.classList.add(
          'pn8sd-live-list'
        );


        attendedRoot.innerHTML =
          attended
            .sort(
              (a,b) =>
                new Date(b.starts_at)
                -
                new Date(a.starts_at)
            )
            .map(
              row =>
                eventCard(
                  row,
                  true
                )
            )
            .join('');

      }

    }

  }


  function communityCard(row) {

    return `
      <article class="pn8sd-community">

        <div class="pn8sd-community__icon">

          ${
            row.cover_image_url
              ? `
                <img
                  src="${escapeHTML(
                    row.cover_image_url
                  )}"
                  alt=""
                >
              `
              : '◌'
          }

        </div>


        <div class="pn8sd-community__copy">

          <div>

            <small>
              ${escapeHTML(
                row.category ||
                'COMMUNITY'
              )}
            </small>

            <h4>
              ${escapeHTML(
                row.name
              )}
            </h4>

          </div>


          <p>
            ${
              row.description
                ? escapeHTML(
                    row.description
                  )
                : 'Your PeerNest student community.'
            }
          </p>


          <div class="pn8sd-community__meta">

            <span>
              ${escapeHTML(
                String(
                  row.member_count || 0
                )
              )}
              members
            </span>

            <span>
              ${escapeHTML(
                row.role || 'member'
              )}
            </span>

          </div>


          <div class="pn8sd-community__actions">

            <a href="/pages/communities">
              Open community →
            </a>

            <button
              type="button"
              data-pn8sd-leave-community="${escapeHTML(
                row.community_id
              )}"
            >
              Leave
            </button>

          </div>

        </div>

      </article>
    `;

  }


  function renderCommunities(
    rows
  ) {

    if (!communitiesRoot) {
      return;
    }


    communitiesRoot.classList.add(
      'pn8sd-community-shell'
    );


    if (!rows.length) {

      communitiesRoot.innerHTML = `
        <span class="pndash-wide-empty__icon">
          ◌
        </span>

        <div>

          <small>
            JOINED COMMUNITIES
          </small>

          <h3>
            You haven't joined a community yet.
          </h3>

          <p>
            Join college, career or interest
            communities and they will appear here.
          </p>

        </div>

        <a href="/pages/communities">
          Discover communities →
        </a>
      `;

      return;

    }


    communitiesRoot.innerHTML = `
      <div class="pn8sd-community-head">

        <div>
          <small>
            JOINED COMMUNITIES
          </small>

          <h3>
            Your communities
          </h3>
        </div>

        <span>
          ${rows.length}
          joined
        </span>

      </div>

      <div class="pn8sd-community-grid">
        ${rows
          .map(
            communityCard
          )
          .join('')}
      </div>
    `;

  }


  async function loadEvents() {

    if (
      !upcomingRoot &&
      !attendedRoot
    ) {
      return;
    }


    try {

      const result =
        await rpc(
          'pn8a_get_my_event_registrations'
        );


      renderEvents(
        Array.isArray(result)
          ? result
          : []
      );

    }
    catch (error) {

      console.error(
        '[PeerNest 8A Student Events]',
        error
      );

    }

  }


  async function loadCommunities() {

    if (!communitiesRoot) {
      return;
    }


    try {

      const result =
        await rpc(
          'pn8a_get_my_communities'
        );


      renderCommunities(
        Array.isArray(result)
          ? result
          : []
      );

    }
    catch (error) {

      console.error(
        '[PeerNest 8A Student Communities]',
        error
      );

    }

  }


  dashboard.addEventListener(
    'click',
    async event => {

      const cancel =
        event.target.closest(
          '[data-pn8sd-cancel-event]'
        );


      if (cancel) {

        cancel.disabled =
          true;

        cancel.textContent =
          'Cancelling…';


        try {

          await rpc(
            'pn8a_cancel_event_registration',
            {
              p_event_id:
                cancel.dataset
                  .pn8sdCancelEvent
            }
          );


          await loadEvents();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not cancel registration.'
          );


          cancel.disabled =
            false;

        }


        return;

      }


      const leave =
        event.target.closest(
          '[data-pn8sd-leave-community]'
        );


      if (leave) {

        const okay =
          window.confirm(
            'Leave this community?'
          );


        if (!okay) {
          return;
        }


        leave.disabled =
          true;

        leave.textContent =
          'Leaving…';


        try {

          await rpc(
            'pn8a_leave_community',
            {
              p_community_id:
                leave.dataset
                  .pn8sdLeaveCommunity
            }
          );


          await loadCommunities();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not leave community.'
          );


          leave.disabled =
            false;

        }

      }

    }
  );


  async function init() {

    let currentSession =
      null;


    try {

      currentSession =
        await window.PeerNestDB
          .getSession();

    }
    catch (_) {}


    if (
      !currentSession?.access_token
    ) {
      return;
    }


    await Promise.all([
      loadEvents(),
      loadCommunities()
    ]);

  }


  if (window.PeerNestDB) {

    init();

  }
  else {

    document.addEventListener(
      'peernest:supabase-ready',
      init,
      {
        once:true
      }
    );

  }

})();
